import SyncOutlinedIcon from '@mui/icons-material/SyncOutlined';
import PropTypes from 'prop-types';
import React from 'react';
import {
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
} from 'reactstrap';

import VisibleScoreList from './visibleScoreList';

class Leaderboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentSelectOption: '',
      dropdownIsOpen: false,
      refreshed: false,
      friendTabIsVisible: true,
    };
    this.handleDropdownClick = this.handleDropdownClick.bind(this);
    this.handleSelectOnClick = this.handleSelectOnClick.bind(this);
    this.initialitateSelectDefaultOption =
      this.initialitateSelectDefaultOption.bind(this);
    this.setLocalStorage = this.setLocalStorage.bind(this);
    this.updateFriendLeaderboard = this.updateFriendLeaderboard.bind(this);
    this.updateEveryoneLeaderboard = this.updateEveryoneLeaderboard.bind(this);
  }

  handleDropdownClick() {
    this.setState({ dropdownIsOpen: !this.state.dropdownIsOpen });
  }

  updateFriendLeaderboard(cleanEveryoneLeaderboard = true) {
    this.props.loadFriendLeaderboard(
      window.localStorage.getItem(this.props.localStorageItem),
    );
    if (cleanEveryoneLeaderboard) {
      this.props.setEveryoneLeaderboard(null);
    }
  }

  updateEveryoneLeaderboard(cleanFriendLeaderboard = true) {
    this.props.loadEveryoneLeaderboard(
      window.localStorage.getItem(this.props.localStorageItem),
    );
    if (cleanFriendLeaderboard) {
      this.props.setFriendLeaderboard(null);
    }
  }

  updateVisibleTab() {
    if (this.state.friendTabIsVisible) {
      this.updateFriendLeaderboard();
    } else {
      this.updateEveryoneLeaderboard();
    }
  }

  handleSelectOnClick(e) {
    this.setState({ dropdownIsOpen: !this.state.dropdownIsOpen });
    const name = e.target.name;
    const value = e.target.value;

    if (name && value && name !== this.state.currentSelectOption) {
      window.localStorage.setItem(this.props.localStorageItem, value);
      this.setState({ currentSelectOption: name });
      this.updateVisibleTab();
    }
  }

  initialitateSelectDefaultOption(option) {
    switch (option) {
      case 'today':
        this.setState({ currentSelectOption: 'TODAY' });
        break;
      case 'thisWeek':
        this.setState({ currentSelectOption: 'THIS WEEK' });
        break;
      case 'thisMonth':
        this.setState({ currentSelectOption: 'THIS MONTH' });
        break;
      case 'allTime':
        this.setState({ currentSelectOption: 'ALL TIME' });
        break;
      default:
        this.setState({ currentSelectOption: '' });
    }
  }

  setLocalStorage() {
    let optionSelect;
    if (window.localStorage.getItem(this.props.localStorageItem)) {
      optionSelect = window.localStorage.getItem(this.props.localStorageItem);
    } else {
      optionSelect = window.localStorage.setItem(
        this.props.localStorageItem,
        'thisWeek',
      );
    }
    this.initialitateSelectDefaultOption(optionSelect);
  }

  componentDidMount() {
    this.setLocalStorage();
    this.updateVisibleTab();
    this.forceUpdate();
  }

  refresh() {
    if (this.state.refreshed) return;
    this.updateVisibleTab();
    this.setState({ refreshed: true });
    this.forceUpdate();
  }

  render() {
    const waiting =
      this.props.friendLeaderboardWaiting ||
      this.props.everyoneLeaderboardWaiting;
    return (
      <div className="leaderboard-container pr-4 pt-4 pl-4 pb-0 w-100">
        <Row className="ml-0 mr-0">
          <Col xs={6} className="text-center d-none d-md-block p-0 m-0">
            <h4>Leaderboard</h4>
          </Col>
          <Col xs={10} md={4} className="text-center pl-1 pr-0 m-0 ">
            <Dropdown
              className="select-container"
              isOpen={this.state.dropdownIsOpen}
              toggle={this.handleDropdownClick}
            >
              <DropdownToggle name="toggle" className="week-selector pl-2 pr-2">
                <span>{this.state.currentSelectOption}</span>{' '}
                {this.state.dropdownIsOpen ? (
                  <i className="icon-expand select-icon rotate down" />
                ) : (
                  <i className="icon-expand select-icon rotate" />
                )}
              </DropdownToggle>
              <DropdownMenu
                onClick={this.handleSelectOnClick}
                className="mt-3 select-dropdown-menu"
              >
                <DropdownItem
                  name="TODAY"
                  value="today"
                  className={
                    this.state.currentSelectOption === 'TODAY'
                      ? 'selected-option'
                      : ''
                  }
                >
                  Today
                </DropdownItem>
                <DropdownItem
                  name="THIS WEEK"
                  value="thisWeek"
                  className={
                    this.state.currentSelectOption === 'THIS WEEK'
                      ? 'selected-option'
                      : ''
                  }
                >
                  This Week
                </DropdownItem>
                <DropdownItem
                  name="THIS MONTH"
                  value="thisMonth"
                  className={
                    this.state.currentSelectOption === 'THIS MONTH'
                      ? 'selected-option'
                      : ''
                  }
                >
                  This Month
                </DropdownItem>
                <DropdownItem
                  name="ALL TIME"
                  value="allTime"
                  className={
                    this.state.currentSelectOption === 'ALL TIME'
                      ? 'selected-option'
                      : ''
                  }
                >
                  All Time
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </Col>
          <Col xs={2}>
            <SyncOutlinedIcon
              className={`refresh-icon${
                this.state.refreshed && !waiting ? '-disabled' : ''
              } ${waiting ? 'refresh-animation' : ''} `}
              onClick={() => this.refresh()}
            />
          </Col>
        </Row>
        <Row className="ml-0 mr-0">
          <Col className="p-0" xs={12}>
            <VisibleScoreList
              user={this.props.user}
              possibleCyclesForUser={this.props.possibleCyclesForUser}
              friendLeaderboardWaiting={this.props.friendLeaderboardWaiting}
              everyoneLeaderboardWaiting={this.props.everyoneLeaderboardWaiting}
              friendTabIsVisible={this.state.friendTabIsVisible}
              setFriendTabIsVisible={(value) => {
                this.setState({ friendTabIsVisible: value });
              }}
              updateFriendLeaderboard={this.updateFriendLeaderboard}
              updateEveryoneLeaderboard={this.updateEveryoneLeaderboard}
              friendLeaderboard={this.props.friendLeaderboard}
              everyoneLeaderboard={this.props.everyoneLeaderboard}
            />
          </Col>
        </Row>
      </div>
    );
  }
}
Leaderboard.propTypes = {
  userId: PropTypes.number,
  friendLeaderboard: PropTypes.array,
  everyoneLeaderboard: PropTypes.array,
  loadEveryoneLeaderboard: PropTypes.func.isRequired,
  loadFriendLeaderboard: PropTypes.func.isRequired,
  localStorageItem: PropTypes.string.isRequired,
  setEveryoneLeaderboard: PropTypes.func.isRequired,
  setFriendLeaderboard: PropTypes.func.isRequired,
};
export default Leaderboard;
